import Vue from 'vue'
import Router from 'vue-router'
import miniApp from '@/pages/miniapp/index/index.vue'
import classifyDetail from '@/pages/miniapp/classifyDetail/classifyDetail.vue'
import miniAppDetail from '@/pages/miniapp/miniAppDetail/miniAppDetail.vue'
import notFound from '@/pages/miniapp/error/notFound.vue'

Vue.use(Router)

export default new Router({
  base: '/cicadas/',
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = document.body.scrollTop
      }
      return {x: 0, y: to.meta.savedPosition || 0}
    }
  },
  routes: [
    {
      path: '/',
      name: 'miniApp',
      component: miniApp,
      meta: {
        keepAlive: true, // 此组件需要被缓存
        isBack: false // 用于判断上一个页面是哪个
      }
    },
    {
      path: '/classifyDetail',
      name: 'classifyDetail',
      component: classifyDetail,
      meta: {
        keepAlive: true, // 此组件需要被缓存
        isBack: false // 用于判断上一个页面是哪个
      }
    },
    {
      path: '/miniAppDetail',
      name: 'miniAppDetail',
      component: miniAppDetail,
      meta: {
        keepAlive: false, // 此组件需要被缓存
        isBack: false // 用于判断上一个页面是哪个
      }
    },
    {
      path: '*',
      name: 'notFound',
      component: notFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js